import {
	GlobalFooter,
	type CustomSection,
	type SocialLinkItem,
} from '@ds-mgnl/marketing';
import { type ImageProps } from '@dsx/react';
import footerLogo from '../../assets/images/ds-logo-color.svg';

export const Footer = () => {
	const logo: ImageProps = {
		src: footerLogo,
		alt: 'Direct Supply Logo',
	};

	const socialLinks: SocialLinkItem[] = [
		{
			href: 'https://www.facebook.com/directsupply',
			site: 'facebook',
		},
		{
			href: 'https://twitter.com/_DirectSupply',
			site: 'twitterX',
		},
		{
			href: 'http://www.linkedin.com/company/direct-supply',
			site: 'linkedin',
		},
		{
			href: 'http://www.youtube.com/c/directsupply',
			site: 'youtube',
		},
	];

	const customSections: CustomSection[] = [
		{
			section: {
				title: 'TELS',
			},
			linkGroups: [
				{
					title: 'Platform',
					links: [
						{
							href: '/building-management-platform/maintenance',
							children: 'Maintenance',
						},
						{
							href: '/building-management-platform/housekeeping',
							children: 'Housekeeping',
						},
						{
							href: '/building-management-platform/capital-management',
							children: 'Capital Management',
						},
						{
							href: '/building-management-platform/unit-turns',
							children: 'Unit Turns',
						},
						{
							href: 'https://www.tels.net/TELSLogin/signin.aspx',
							target: '_blank',
							children: 'Sign in',
						},
					],
				},
				{
					title: 'Services',
					links: [
						{
							href: '/services/routine-and-emergency-repairs',
							children: 'Route and Emergency Repairs',
						},
						{
							href: '/services/planned-projects',
							children: 'Planned Projects',
						},
						{
							href: '/services/recurring-maintenance-programs',
							children: 'Recurring Maintenance Programs',
						},
					],
				},
				{
					title: 'Resources',
					links: [
						{ href: '/resources/blogs', children: 'Expertise' },
						{ href: '/resources/case-studies', children: 'Case Studies' },
					],
				},
			],
		},
	];

	return (
		<GlobalFooter
			logo={logo}
			socialLinks={socialLinks}
			customSections={customSections}
		/>
	);
};
